import logger from '@/modules/Logger';

export default {
  /**
   * Route remote audio playback to the selected speaker (output) device.
   *
   * Agora plays a RemoteAudioTrack through its own internal media element, not the
   * #remoteVideo element (which is muted), so setSinkId on #remoteVideo does not move
   * the audio the user hears. RemoteAudioTrack.setPlaybackDevice is the SDK's supported
   * way to change the output device for remote audio.
   *
   * @param {string} deviceId audio output device id
   */
  async setAudioOutputDevice(deviceId) {
    this.audioOutputDevice = deviceId;

    const audioTrack = this.remoteUserRtc && this.remoteUserRtc.audioTrack;
    if (!audioTrack) {
      logger.debug('[Agora] No remote audio track to apply speaker to yet', {
        operation: 'device:audio-output-change'
      });
      return false;
    }

    if (typeof audioTrack.setPlaybackDevice !== 'function') {
      logger.warn('[Agora] setPlaybackDevice not supported by SDK/browser', {
        operation: 'device:audio-output-change'
      });
      return false;
    }

    try {
      await audioTrack.setPlaybackDevice(deviceId);
      logger.info(`[Agora] Remote audio output device set: ${deviceId}`, {
        operation: 'device:audio-output-change'
      });
      return true;
    } catch (error) {
      logger.error('[Agora] Failed to set remote audio output device', {
        operation: 'device:audio-output-change',
        reason: error.message || error,
        event_type: 5,
        lesson_id: this.lessonId
      });
      return false;
    }
  }
};
